const colors = {
  darkPurple: '#231d54',
  purple: '#8100ff',
  lightPurple: '#9388db',
  blueLight: "#788eec",
  lightGrayPurple: '#f7f7fb',
  pink: '#ff3d69',
  gray: '#797777',
  white: '#ffffff',
  black: '#000000',
  red: '#ff0000',
  lightsteelblue: '#b0c4de',
  mediumseagreen: '#3cb371',
  seagreen: '#2e8b57',
  mediumvioletred: '#c71585',
  deeppink: '#ff1493',
  lightyellow: '#ffffe0',
  aquamarine: '#7fffd4',
  floralwhite: '#fffaf0',
  khaki: '#f0e68c',
  yellow: '#ffff00',
  clearBlack: '#000000c0',
}

export { colors }
